(function () {
  'use strict';

  var SERVICE_PRICE = 1500;
  var ARTWORK_MAX = 20 * 1024 * 1024;
  var REFERENCE_MAX = 10 * 1024 * 1024;
  var ALLOWED_TYPES = ['image/png', 'image/jpeg', 'application/pdf'];

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-AE', {
        style: 'currency',
        currency: 'AED',
        minimumFractionDigits: cents % 100 ? 2 : 0,
        maximumFractionDigits: 2
      }).format(cents / 100).replace('AED', 'AED ');
    } catch (error) {
      return 'AED ' + (cents / 100).toFixed(cents % 100 ? 2 : 0);
    }
  }

  function fileSize(bytes) {
    if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  function groupId() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'fb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function getForm(root) {
    var selector = 'form[data-type="add-to-cart-form"]';
    return document.getElementById('product-form-' + root.dataset.productId) ||
      root.closest(selector) ||
      root.closest('product-form')?.querySelector(selector) ||
      root.closest('.productView')?.querySelector(selector) ||
      root.parentElement?.querySelector(selector) ||
      document.querySelector(selector);
  }

  function appendCustomizerFields(formData, root) {
    var cleared = {};
    root.querySelectorAll('input, textarea, select').forEach(function (field) {
      if (!field.name || field.disabled || field.name === 'designOption') return;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      if (!cleared[field.name]) {
        formData.delete(field.name);
        cleared[field.name] = true;
      }
      if (field.type === 'file') {
        Array.from(field.files || []).forEach(function (file) { formData.append(field.name, file); });
      } else {
        formData.append(field.name, field.value);
      }
    });
  }

  function getQuantity(form) {
    var input = form.querySelector('[name="quantity"]');
    return Math.max(1, parseInt(input && input.value, 10) || 1);
  }

  function getVariantPrice(root, form) {
    var id = form.querySelector('[name="id"]')?.value;
    var variants = root._fbVariants;
    if (!variants) {
      try {
        variants = JSON.parse(root.querySelector('[data-fb-variants]')?.textContent || '[]');
      } catch (error) {
        variants = [];
      }
      root._fbVariants = variants;
    }
    if (Array.isArray(variants)) {
      var match = variants.find(function (variant) { return String(variant.id) === String(id); });
      if (match && Number.isFinite(Number(match.price))) return Number(match.price);
    }
    return Number(root.dataset.basePrice) || 0;
  }

  function mainButton(form) {
    return form.querySelector('[type="submit"][name="add"], [data-btn-addtocart], .product-form__submit');
  }

  function buttonPrefix(button, fallback) {
    var source = String(fallback || (button && button.textContent) || 'Add To Cart').trim();
    return source.replace(/\s*[-—]\s*AED\s*[\d,.]+\s*$/i, '').trim() || 'Add To Cart';
  }

  function setButtonPrice(button, prefix, cents) {
    if (!button || button.disabled) return;
    button.textContent = prefix + ' - AED ' + (cents / 100).toFixed(2);
  }

  function setBusy(root, form, busy) {
    root.classList.toggle('is-busy', busy);
    var button = mainButton(form);
    if (button) {
      button.disabled = busy;
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
  }

  function requestJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok) throw new Error(body.description || body.message || 'Something went wrong. Please try again.');
        return body;
      });
    });
  }

  function validateFile(file, maxBytes) {
    if (!file) return '';
    if (ALLOWED_TYPES.indexOf(file.type) === -1) return 'Please upload a PNG, JPG or PDF file.';
    if (file.size > maxBytes) return 'This file is too large. Please choose a smaller file.';
    return '';
  }

  function activeOption(root) {
    return root.querySelector('input[name="designOption"]:checked')?.value || '';
  }

  function publicOption(option) {
    return option === 'ready-made' ? 'Ready Design' : option === 'upload' ? 'Upload Artwork' : 'Design It for Me';
  }

  function updateCartNoteFallback(cart) {
    if (!cart || !Array.isArray(cart.items)) return Promise.resolve();
    var start = '[FANN BLISS PERSONALIZATION]';
    var end = '[/FANN BLISS PERSONALIZATION]';
    var current = cart.note || '';
    var startIndex = current.indexOf(start);
    var endIndex = current.indexOf(end);
    if (startIndex !== -1 && endIndex > startIndex) {
      current = (current.slice(0, startIndex) + current.slice(endIndex + end.length)).trim();
    }
    var lines = [];
    cart.items.forEach(function (item) {
      var properties = item.properties || {};
      if (!properties['Personalization Option'] || properties['_FB Service Item'] === 'true') return;
      lines.push(item.product_title + ' × ' + item.quantity);
      Object.keys(properties).forEach(function (key) {
        if (key.charAt(0) === '_' || !properties[key]) return;
        lines.push(key + ': ' + properties[key]);
      });
      lines.push('—');
    });
    var generated = lines.length ? start + '\n' + lines.join('\n') + '\n' + end : '';
    var note = [current, generated].filter(Boolean).join('\n\n');
    return requestJson(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note })
    });
  }

  function refreshSideCart(cart) {
    var cartApi = window.FannCartV2;
    if (cartApi && typeof cartApi.refreshSideCart === 'function') {
      return cartApi.refreshSideCart(cart, true);
    }

    return fetch(window.Shopify.routes.root + 'cart?view=ajax_side_cart', { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var wrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
        if (wrapper) wrapper.innerHTML = html;
        var visibleCount = cart.items.reduce(function (count, item) {
          return count + ((item.properties || {})['_FB Service Item'] === 'true' ? 0 : item.quantity);
        }, 0);
        document.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = visibleCount; });
        document.body.classList.add('cart-sidebar-show');
      });
  }

  function Customizer(root) {
    this.root = root;
    this.form = getForm(root);
    this.button = this.form && mainButton(this.form);
    this.defaultButtonText = this.button ? this.button.textContent.trim() : 'Add to cart';
    this.defaultButtonPrefix = buttonPrefix(this.button, this.defaultButtonText);
    this.submitHandler = this.submit.bind(this);
    this.init();
  }

  Customizer.prototype.init = function () {
    var self = this;
    if (!this.form) return;
    this.form.enctype = 'multipart/form-data';
    var productView = this.root.closest('.productView') || document;
    if (productView !== document) productView.classList.add('fb-has-customizer');
    productView.querySelectorAll('.shopify-payment-button, .productView-payment').forEach(function (node) {
      node.hidden = true;
    });
    var stickyForm = document.getElementById('product-form-sticky-' + this.root.dataset.productId);
    if (stickyForm && stickyForm.closest('.sticky-product')) stickyForm.closest('.sticky-product').hidden = true;

    this.root.querySelectorAll('input[name="designOption"]').forEach(function (input) {
      input.addEventListener('change', function () { self.switchOption(input.value); });
    });

    this.root.querySelectorAll('[data-fb-counter-input]').forEach(function (input) {
      var counter = input.closest('.fb-input-wrap')?.querySelector('[data-fb-counter]');
      var update = function () {
        if (counter) counter.textContent = input.value.length + '/' + input.maxLength;
      };
      input.addEventListener('input', update);
      update();
    });

    this.setupArtwork();
    this.setupReference();
    this.setupColours();

    document.addEventListener('fann:design-selected', function (event) {
      self.setReadyDesign(event.detail || {});
    });

    this.form.addEventListener('change', function (event) {
      if (event.target.matches('[name="quantity"], [name="id"]')) self.updatePrice();
    });
    this.form.addEventListener('input', function (event) {
      if (event.target.matches('[name="quantity"]')) self.updatePrice();
    });
    document.addEventListener('variant:changed', function () { self.updatePrice(); });
    document.addEventListener('submit', function (event) {
      var submittedForm = event.target;
      if (!submittedForm || !submittedForm.matches || !submittedForm.matches('form[data-type="add-to-cart-form"]')) return;
      var submittedId = submittedForm.getAttribute('id');
      if (submittedId === 'product-form-sticky-' + self.root.dataset.productId) {
        event.preventDefault();
        event.stopImmediatePropagation();
        self.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (submittedId !== 'product-form-' + self.root.dataset.productId) return;
      self.form = submittedForm;
      self.button = mainButton(submittedForm);
      self.submit(event);
    }, true);
    document.addEventListener('click', function (event) {
      var addButton = event.target.closest && event.target.closest('[type="submit"][name="add"], [data-btn-addtocart]');
      if (!addButton) return;
      var clickedForm = addButton.closest('form[data-type="add-to-cart-form"]');
      if (!clickedForm) return;
      var clickedId = clickedForm.getAttribute('id');
      if (clickedId === 'product-form-sticky-' + self.root.dataset.productId) {
        event.preventDefault();
        event.stopImmediatePropagation();
        self.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (clickedId !== 'product-form-' + self.root.dataset.productId) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      self.form = clickedForm;
      self.button = addButton;
      self.submit(event);
    }, true);

    this.switchOption(activeOption(this.root));
  };

  Customizer.prototype.switchOption = function (option) {
    var self = this;
    this.showError('');
    this.root.querySelectorAll('[data-fb-panel]').forEach(function (panel) {
      var active = panel.dataset.fbPanel === option;
      panel.hidden = !active;
      panel.querySelectorAll('input, textarea, select').forEach(function (field) {
        field.disabled = !active;
      });
      if (active) {
        var optionField = panel.querySelector('[data-fb-property-option]');
        if (!optionField) {
          optionField = document.createElement('input');
          optionField.type = 'hidden';
          optionField.name = 'properties[Personalization Option]';
          optionField.dataset.fbPropertyOption = '';
          panel.appendChild(optionField);
        }
        optionField.value = publicOption(option);
      }
    });

    var isCustom = option === 'custom';
    this.root.querySelector('[data-fb-group-id]').disabled = !isCustom;
    this.root.querySelector('[data-fb-service-property]').disabled = !isCustom;
    this.root.querySelector('[data-fb-fee-property]').disabled = !isCustom;
    this.root.querySelectorAll('[data-fb-option-card]').forEach(function (card) {
      card.classList.toggle('is-selected', card.dataset.fbOptionCard === option);
    });

    this.updatePrice();
    window.setTimeout(function () {
      var selected = self.root.querySelector('[data-fb-panel="' + option + '"]');
      if (selected) selected.dispatchEvent(new CustomEvent('fann:panel-shown'));
    }, 0);
  };

  Customizer.prototype.updatePrice = function () {
    var option = activeOption(this.root);
    var quantity = getQuantity(this.form);
    var base = getVariantPrice(this.root, this.form);
    var service = option === 'custom' ? SERVICE_PRICE : 0;
    var bottleTotal = base * quantity;
    var serviceTotal = service * quantity;

    var bottleNode = this.root.querySelector('[data-fb-bottle-total]');
    var serviceNode = this.root.querySelector('[data-fb-service-total]');
    var groupNode = this.root.querySelector('[data-fb-group-total]');
    if (bottleNode) bottleNode.textContent = money(bottleTotal);
    if (serviceNode) serviceNode.textContent = money(serviceTotal);
    if (groupNode) groupNode.textContent = money(bottleTotal + serviceTotal);
    setButtonPrice(this.button, this.defaultButtonPrefix, base + service);
  };

  Customizer.prototype.setupArtwork = function () {
    var self = this;
    var input = this.root.querySelector('[data-fb-artwork-file]');
    var preview = this.root.querySelector('[data-fb-upload-preview]');
    if (!input || !preview) return;
    var empty = this.root.querySelector('[data-fb-upload-zone] .fb-upload__empty');
    var image = preview.querySelector('[data-fb-upload-image]');
    var name = preview.querySelector('[data-fb-upload-name]');
    var meta = preview.querySelector('[data-fb-upload-meta]');

    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      var error = validateFile(file, ARTWORK_MAX);
      if (error) {
        input.value = '';
        self.showError(error);
        return;
      }
      self.showError('');
      if (!file) return;
      name.textContent = file.name;
      meta.textContent = fileSize(file.size) + (file.type === 'application/pdf' ? ' • PDF' : ' • Image');
      if (file.type.indexOf('image/') === 0) image.src = URL.createObjectURL(file);
      else image.removeAttribute('src');
      image.hidden = file.type === 'application/pdf';
      preview.hidden = false;
      empty.hidden = true;
    });

    preview.querySelector('[data-fb-remove-upload]')?.addEventListener('click', function () {
      input.value = '';
      preview.hidden = true;
      empty.hidden = false;
    });
  };

  Customizer.prototype.setupReference = function () {
    var self = this;
    var input = this.root.querySelector('[data-fb-reference-file]');
    var label = this.root.querySelector('[data-fb-reference-label]');
    if (!input || !label) return;
    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      var error = validateFile(file, REFERENCE_MAX);
      if (error) {
        input.value = '';
        self.showError(error);
        label.textContent = 'Drop image here or browse';
        return;
      }
      self.showError('');
      if (file) label.textContent = file.name + ' • ' + fileSize(file.size);
    });
  };

  Customizer.prototype.setupColours = function () {
    var row = this.root.querySelector('[data-fb-colours]');
    var value = this.root.querySelector('[data-fb-colours-value]');
    var help = this.root.querySelector('[data-fb-colour-help]');
    if (!row || !value) return;
    row.addEventListener('change', function (event) {
      var checked = Array.from(row.querySelectorAll('input:checked'));
      if (checked.length > 3) {
        event.target.checked = false;
        checked = Array.from(row.querySelectorAll('input:checked'));
      }
      value.value = checked.map(function (input) { return input.value; }).join(', ');
      if (help) help.textContent = checked.length ? checked.length + ' of 3 selected' : 'Select up to three';
    });
  };

  Customizer.prototype.setReadyDesign = function (design) {
    var panel = this.root.querySelector('[data-fb-panel="ready-made"]');
    if (!panel) return;
    panel.querySelector('[data-fb-design-name]').value = design.name || '';
    panel.querySelector('[data-fb-design-code]').value = design.id || '';
    panel.querySelector('[data-fb-design-image]').value = design.image || design.thumbnail || '';
    var selected = panel.querySelector('[data-fb-ready-selection]');
    var empty = panel.querySelector('.fb-design-trigger__empty');
    selected.querySelector('[data-fb-ready-name]').textContent = design.name || 'Selected design';
    selected.querySelector('[data-fb-ready-code]').textContent = design.id ? 'Design ' + design.id : '';
    var image = selected.querySelector('[data-fb-ready-image]');
    image.src = design.thumbnail || design.image || '';
    image.alt = design.image_alt || design.name || 'Selected ready design';
    selected.hidden = false;
    empty.hidden = true;
    this.showError('');
  };

  Customizer.prototype.showError = function (message) {
    var box = this.root.querySelector('[data-fb-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
    if (message) box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  Customizer.prototype.validate = function () {
    var option = activeOption(this.root);
    var panel = this.root.querySelector('[data-fb-panel="' + option + '"]');
    if (!panel) return 'Please choose a personalization option.';
    if (option === 'ready-made' && !panel.querySelector('[data-fb-design-code]').value) {
      return 'Please choose a ready design before adding this bottle.';
    }
    if (option === 'ready-made') {
      var readyName = panel.querySelector('input[name="properties[Name]"]');
      if (!readyName || !readyName.value.trim()) return 'Please add the name for this ready design.';
    }
    if (option === 'upload') {
      var artwork = panel.querySelector('[data-fb-artwork-file]');
      if (!artwork.files || !artwork.files[0]) return 'Please upload your artwork before adding this bottle.';
      var fileError = validateFile(artwork.files[0], ARTWORK_MAX);
      if (fileError) return fileError;
    }
    var invalidField = Array.from(panel.querySelectorAll('[required]')).find(function (field) {
      return !field.disabled && typeof field.checkValidity === 'function' && !field.checkValidity();
    });
    if (invalidField) {
      invalidField.focus();
      return 'Please complete the highlighted personalization details.';
    }
    return '';
  };

  Customizer.prototype.submit = function (event) {
    var self = this;
    if (this.root.dataset.fbSubmitting === 'true') return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var error = this.validate();
    if (error) {
      this.showError(error);
      return;
    }

    var option = activeOption(this.root);
    var quantity = getQuantity(this.form);
    var linkedId = option === 'custom' ? groupId() : '';
    var groupField = this.root.querySelector('[data-fb-group-id]');
    if (groupField) groupField.value = linkedId;
    var formData = new FormData(this.form);
    formData.delete('designOption');
    appendCustomizerFields(formData, this.root);

    this.root.dataset.fbSubmitting = 'true';
    setBusy(this.root, this.form, true);
    this.showError('');

    var addedBottle;
    requestJson(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    }).then(function (item) {
      addedBottle = item;
      if (option !== 'custom') return item;
      return requestJson(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(self.root.dataset.serviceVariantId),
          quantity: quantity,
          properties: {
            '_FB Service Item': 'true',
            '_FB Parent Group': linkedId,
            'Design Service': 'AED 15 per bottle',
            'Service For': self.root.dataset.productTitle
          }
        })
      }).catch(function (serviceError) {
        if (!addedBottle || !addedBottle.key) throw serviceError;
        return requestJson(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: addedBottle.key, quantity: 0 })
        }).then(function () { throw serviceError; });
      });
    }).then(function () {
      return requestJson(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
    }).then(function (cart) {
      if (window.FannCartV2 && typeof window.FannCartV2.updateOrderNote === 'function') {
        return window.FannCartV2.updateOrderNote(cart).then(function () { return cart; });
      }
      return updateCartNoteFallback(cart).then(function () { return cart; });
    }).then(function (cart) {
      return refreshSideCart(cart);
    }).catch(function (submitError) {
      self.showError(submitError.message || 'We could not add this item. Please try again.');
    }).finally(function () {
      self.root.dataset.fbSubmitting = 'false';
      setBusy(self.root, self.form, false);
      self.updatePrice();
    });
  };

  function init() {
    document.querySelectorAll('[data-fb-customizer]').forEach(function (root) {
      if (root.dataset.fbInitialized) return;
      root.dataset.fbInitialized = 'true';
      new Customizer(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
